import React, { useState } from "react";
import "./DeliveryInvoiceEdit.css";
import CustomCsPcInput from "../../components/dms_common/CustomCsPcInput";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Checkbox from "@mui/material/Checkbox";
import { DeliveryInvoiceBatchDetails } from "../../types/types";
import { getUomLabel } from "../../components/dms_common/DmsUtils";


const BatchListItem = ({
  batch,
  editBatchId,
  isSelected,
  onSelect,
  isUpdated,
  otherUnitName
}: {
  batch: DeliveryInvoiceBatchDetails;
  editBatchId?: (batchId: string)=>void;
  isSelected: boolean;
  onSelect: () => void;
  isUpdated?: boolean
  otherUnitName?: string;
}) => {
  
  const {caseUnitLabel,otherUnitLabel,packUnitLabel} = getUomLabel();
  const shouldShowTick = isSelected || isUpdated;
  return (
    <div
      className={`batchContainer-delivery ${(isSelected || isUpdated) && "batch-selected-delivery"}`}
      onClick={onSelect}
    >
      <span className={`${(isSelected || isUpdated) && "batch-selected-delivery-text"}`} style={{ display: "flex", alignItems: "center", gap: "6px" }}>
        {editBatchId ?
          <> <input
            onClick={(e) => e.stopPropagation()}
            className="cs-pc-input"
            value={batch.batchId}
            onChange={(e) => editBatchId(e.target.value)}
          />
            {isUpdated && (
              <CheckCircleIcon
                style={{
                  color: "#00c6b0",
                  fontSize: "14px",
                }}
              />
            )}
          </>
          :
          <>
            {batch?.batchId}{" "}
            {isUpdated && (
              <CheckCircleIcon
                style={{
                  color: "#00c6b0",
                  fontSize: "14px",
                }}
              />
            )}
          </>
        }
      </span>
      <div className="cs-pc-and-checkbox">
        <div className="batch-input-container">
          {caseUnitLabel && <CustomCsPcInput
            value={batch.caseQty ?? 0}
            onChange={() => null}
            label="Cs"
            percentage={95}
            borderColor={isSelected ? "#00C6B1" : "#d9d9d9"}
            borderWidth="0.5px"
            readOnly={true}
          />}
          {otherUnitLabel && <CustomCsPcInput
            value={batch.otherQty ?? 0}
            onChange={() => null}
            label= {otherUnitName ? otherUnitName: "Other"}
            percentage={95}
            borderColor={isSelected ? "#00C6B1" : "#d9d9d9"}
            borderWidth="0.5px"
            readOnly={true}
          />}
          {packUnitLabel && <CustomCsPcInput
            value={batch.pieceQty ?? 0}
            onChange={() => null}
            label="Pc"
            percentage={95}
            borderColor={isSelected ? "#00C6B1" : "#d9d9d9"}
            borderWidth="0.5px"
            readOnly={true}
          />}
        </div>
        <input
          className="batchListItem-radio-button"
          type="radio"
          id="selected"
          checked={isSelected} />
      </div>
    </div>
  );
};

export default BatchListItem;